import { CLICKSTREAM_EVENT_ENVELOPES, RegisteredClickstreamEvents } from '../events/registeredEvents';
import { getEventClientDate } from './getEventClientDate';

export const createClickstreamEventEnvelope = (event: RegisteredClickstreamEvents) => ({
    ...CLICKSTREAM_EVENT_ENVELOPES[event],
    event_client_start_dtm: getEventClientDate(),
});
